export default "__VITE_ASSET__CwNAeIKJ__"